import React from 'react'
import {
    Box,
    Button,
    Divider,
    Grid,
    IconButton,
    MenuItem,
    Select,
    TextField,
    Typography,
  } from "@mui/material";
  import dayjs from "dayjs";
  import moment from "moment";
  import { Field, Form, Formik } from "formik";
  import { Delete } from '@mui/icons-material';
  import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { color } from "../../../StyleData/Config";
  
  import { TimePicker } from "@mui/x-date-pickers/TimePicker";
  const BreakEntry = ({ breakItem, index, handleBreakChange, handleDeleteBreak }) => {
    return (
      <Grid container spacing={1} alignItems="center">

<Grid item>
    <Typography
      sx={{
        fontWeight: color.labelFontWeight,
        fontSize: color.labelFont,
        color: color.labelColor,
      }}
    >
      {index + 1}
    </Typography>
  </Grid>
        <Grid item xs={2} mb={1}>
    
          <Field
            as={TextField}
            size="small"
            type="text"
            name={`breaks[${index}].code`} 
            placeholder="Enter Break Code"
            fullWidth
            value={breakItem.code || ''}
            onChange={(e) => handleBreakChange(index, 'code', e.target.value)}
            sx={{
              ".MuiInputBase-input": {
                "&::placeholder": {
                  opacity: 1,
                  color: color.placeholderColor,
                  fontSize: "13px",
                },
              },
            }}
          />
        </Grid>
        <Grid item xs={2} mb={1}>
    
          <Field
            as={TextField}
            size="small"
            type="text"
            name={`breaks[${index}].breakName`}
            placeholder="Enter Break Name"
            fullWidth
            value={breakItem.breakName || ''}
            onChange={(e) => handleBreakChange(index, 'breakName', e.target.value)}
            sx={{
              ".MuiInputBase-input": {
                "&::placeholder": {
                  opacity: 1,
                  color: color.placeholderColor,
                  fontSize: "13px",
                },
              },
            }}
          />
        </Grid>
        <Grid item xs={2} mb={1}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Field name={`breaks[${index}].startTime`} value={breakItem.startTime || ''}>
            {({ field, form }) => {
              return (
                <TimePicker
                  value={field.value ? dayjs(field.value, "HH:mm:ss") : null}
                  onChange={(time) => handleBreakChange(index, 'startTime', time ? time.format("HH:mm:ss") : '')}
                  slotProps={{
                    textField: {
                      size: "small",
                      fullWidth: true,
                    },
                  }}
                />
              );
            }}
          </Field>
        </LocalizationProvider>
      </Grid>

      <Grid item xs={2} mb={1}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Field name={`breaks[${index}].endTime`} value={breakItem.endTime || ''}>
            {({ field, form }) => {
              return (
                <TimePicker
                  value={field.value ? dayjs(field.value, "HH:mm:ss") : null}
                  onChange={(time) => handleBreakChange(index, 'endTime', time ? time.format("HH:mm:ss") : '')}
                  minTime={breakItem.startTime ? dayjs(breakItem.startTime, "HH:mm:ss") : undefined}  
                  slotProps={{
                    textField: {
                      size: "small",
                      fullWidth: true,
                    },
                  }}
                />
              );
            }}
          </Field>
        </LocalizationProvider>
      </Grid>
        <Grid item xs={2} mb={1}>
  <Field
    as={TextField}
    size="small"
    type="text"
    name={`breaks[${index}].durationInHours`} 
    fullWidth
    value={breakItem.durationInHours || "0h 0m"}
    readOnly
    InputProps={{
      readOnly: true, // Prevent typing in the text field
      style: { pointerEvents: "none" },
      endAdornment: null, // Disable mouse actions
    }}
    sx={{
      ".MuiInputBase-input": {
        "&::placeholder": {
          opacity: 1,
          color: color.placeholderColor,
          fontSize: "13px",
        },
      },
    }}
  />
</Grid>

        <Grid item xs={1}  mb={1}>
          <IconButton onClick={() => handleDeleteBreak(breakItem.id, index)}>
            <Delete />
          </IconButton>
        </Grid>
      </Grid>
    );
  };
  

export default BreakEntry